import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import MediaQuery from '@ynap/media-query';
import Carousel from '../Carousel/Carousel';

const bem = new BEMHelper('StyledCarousel');

/* TODO: TYS-1433 Add tracking to StyledCarousel */
const StyledCarousel = ({ slidesLength, carouselConfig, carouselClassNames = {}, children, onNextClick, onPrevClick, useDefaultCarouselIndex = true }) => {
    const carouselRender = (config = {}) => {
        const carouselVisible = slidesLength >= config.minProducts;
        if (!carouselVisible) return <div className={bem('slidesWrapper')}>{children}</div>;

        return (
            <Carousel
                slidesToShow={config.slidesToShow}
                slidesToScroll={config.slidesToScroll}
                pageComponent={null}
                classNames={carouselClassNames}
                onNextClick={onNextClick}
                onPrevClick={onPrevClick}
                useDefaultCarouselIndex={useDefaultCarouselIndex}
            >
                {children}
            </Carousel>
        );
    };

    return (
        <div className={bem('carousel', slidesLength === 3)}>
            <MediaQuery
                screens={{
                    phone: () => carouselRender(carouselConfig('mobile')),
                    tablet: () => carouselRender(carouselConfig('tablet')),
                    desktop: () => carouselRender(carouselConfig('desktop')),
                }}
            />
        </div>
    );
};

StyledCarousel.propTypes = {
    slidesLength: PropTypes.number.isRequired,
    carouselConfig: PropTypes.func.isRequired,
    carouselClassNames: PropTypes.object,
    children: PropTypes.node.isRequired,
    onNextClick: PropTypes.func,
    onPrevClick: PropTypes.func,
    useDefaultCarouselIndex: PropTypes.bool,
};

export default StyledCarousel;
